@if (editableRoleLimit && !canModify) {
  <span [matTooltip]="'BANNER_FAIL_RIGHTS' | translate">{{ role | translate }}</span>
} @else {
  <mat-button-toggle-group name="role"
    aria-label="Role selection"
    [attr.data-color]="color"
    [disabled]="disabled"
    [value]="role"
    (change)="onSelectionChange($event)">
    @for (roleName of roles; track roleName) {
      <mat-button-toggle
        [ngStyle]="{'display': editableRoleLimit !== 'administrator' && roleName.value === 'administrator' ? 'none' : 'initial'}"
        [value]="roleName.value"
        [disabled]="roleName.disabled"
        [checked]="roleName.value === role">
        {{ roleName.text | translate }}
      </mat-button-toggle>
    }
  </mat-button-toggle-group>
}
